module.exports = [
    'account',
    'account-box-outline',
    'account-card-details',
    'account-card-details-outline',
    'account-check',
    'account-child',
    'account-child-circle',
    'account-child-outline',
    'account-circle',
    'account-edit',
    'account-edit-outline',
    'account-group',
    'account-multiple',
    'account-network',
    'account-search',
    'account-star',
    'account-tie',
    'account-tie-outline',
    'airballoon',
    'airplane',
    'alarm',
    'alarm-check',
    'album',
    'alert-circle-outline',
    'alert-outline',
    'alphabetical',
    'apps',
    'arrow-down-bold-circle',
    'arrow-down-bold-circle-outline',
    'arrow-down-drop-circle',
    'arrow-down-drop-circle-outline',
    'arrow-expand-all',
    'arrow-left',
    'arrow-left-drop-circle',
    'arrow-left-drop-circle-outline',
    'arrow-right',
    'arrow-right-drop-circle',
    'arrow-right-drop-circle-outline',
    'at',
    'attachment',
    'baby',
    'baby-bottle',
    'baby-carriage',
    'baidu',
    'bank',
    'basket',
    'beach',
    'beaker',
    'beaker-outline',
    'beer',
    'bell',
    'bell-outline',
    'bike',
    'binoculars',
    'blinds',
    'blur',
    'book',
    'book-multiple',
    'book-open',
    'book-open-variant',
    'bookmark',
    'bookmark-outline',
    'bookmark-plus',
    'bowling',
    'briefcase',
    'briefcase-outline',
    'brightness-2',
    'brightness-percent',
    'broom',
    'bullhorn',
    'bullseye-arrow',
    'bus',
    'cake-variant',
    'calculator',
    'calendar',
    'calendar-alert',
    'calendar-check',
    'calendar-check-outline',
    'calendar-clock',
    'calendar-edit',
    'calendar-month',
    'calendar-month-outline',
    'calendar-question',
    'calendar-text',
    'call-merge',
    'camcorder',
    'camera',
    'camera-burst',
    'car',
    'card-account-details',
    'card-account-details-outline',
    'cards',
    'cart',
    'cash',
    'cash-check',
    'cash-multiple',
    'cellphone-android',
    'chart-areaspline',
    'chart-bar',
    'chart-line',
    'chart-pie',
    'check-decagram',
    'checkbox-blank',
    'checkbox-blank-circle',
    'checkbox-blank-circle-outline',
    'checkbox-marked-outline',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'city',
    'clipboard-check-outline',
    'clipboard-outline',
    'clipboard-plus',
    'clipboard-plus-outline',
    'clipboard-text',
    'clipboard-text-outline',
    'clock',
    'clock-outline',
    'cloud',
    'code-greater-than',
    'code-less-than',
    'coffee',
    'comment',
    'comment-question-outline',
    'comment-search',
    'comment-search-outline',
    'comment-text-outline',
    'compass',
    'console',
    'content-paste',
    'cow',
    'creation',
    'credit-card',
    'credit-card-check',
    'credit-card-check-outline',
    'crosshairs-gps',
    'currency-usd',
    'currency-usd-circle',
    'currency-usd-circle-outline',
    'cursor-default-click',
    'cursor-default-click-outline',
    'death-star',
    'death-star-variant',
    'discord',
    'dna',
    'doctor',
    'duck',
    'earth',
    'email',
    'emoticon',
    'facebook',
    'facebook-box',
    'factory',
    'ferry',
    'file',
    'file-document-box',
    'file-tree',
    'filmstrip',
    'fingerprint',
    'fire',
    'fish',
    'flag',
    'flag-checkered',
    'flash',
    'flower',
    'flower-outline',
    'folder',
    'folder-google-drive',
    'folder-star',
    'food',
    'food-apple',
    'food-variant',
    'format-list-bulleted-square',
    'format-paint',
    'gamepad-variant',
    'gas-station',
    'gift',
    'github-circle',
    'github-face',
    'glass-cocktail',
    'google',
    'google-circles',
    'google-circles-extended',
    'google-drive',
    'google-maps',
    'google-plus',
    'hand-heart',
    'hand-heart-outline',
    'handshake',
    'handshake-outline',
    'hanger',
    'head-heart',
    'head-heart-outline',
    'headphones',
    'headset',
    'heart',
    'heart-circle',
    'heart-circle-outline',
    'heart-pulse',
    'help-circle',
    'help-circle-outline',
    'home',
    'hospital',
    'hotel',
    'image-area',
    'image-filter',
    'image-filter-drama',
    'image-filter-none',
    'information-outline',
    'instagram',
    'key',
    'lan',
    'laptop',
    'leaf',
    'lightbulb',
    'lightbulb-on',
    'lightbulb-on-outline',
    'link',
    'link-variant',
    'linkedin',
    'linkedin-box',
    'linux',
    'lock',
    'lock-check',
    'lock-check-outline',
    'looks',
    'loupe',
    'magnify',
    'magnify-minus',
    'magnify-plus',
    'magnify-plus-outline',
    'map',
    'map-marker',
    'marker-check',
    'math-compass',
    'medical-bag',
    'menu',
    'message',
    'message-plus-outline',
    'microphone',
    'minus',
    'minus-box',
    'minus-box-outline',
    'monitor-cellphone',
    'motorbike',
    'multiplication',
    'navigation',
    'needle',
    'new-box',
    'newspaper',
    'numeric-0-box',
    'numeric-0-box-outline',
    'numeric-1-box',
    'numeric-1-box-outline',
    'numeric-2-box',
    'numeric-2-box-outline',
    'numeric-3-box',
    'numeric-3-box-outline',
    'numeric-4-box',
    'numeric-4-box-outline',
    'numeric-5-box',
    'numeric-5-box-outline',
    'numeric-6-box',
    'numeric-6-box-outline',
    'numeric-7-box',
    'numeric-7-box-outline',
    'numeric-8-box',
    'numeric-8-box-outline',
    'numeric-9-box',
    'numeric-9-box-outline',
    'open-in-new',
    'package-variant',
    'palette',
    'paw',
    'paw-outline',
    'pencil',
    'phone',
    'piggy-bank',
    'piggy-bank-outline',
    'pill',
    'pin',
    'pine-tree',
    'play',
    'play-circle-outline',
    'plus',
    'plus-box',
    'plus-box-outline',
    'prescription',
    'presentation',
    'printer',
    'puzzle',
    'puzzle-outline',
    'rocket',
    'rss',
    'rss-box',
    'run',
    'school',
    'script',
    'seal',
    'seal-variant',
    'send',
    'settings',
    'shield-check',
    'shield-check-outline',
    'sign-direction',
    'signal',
    'silverware-variant',
    'sina-weibo',
    'smoking-off',
    'snapchat',
    'snowflake',
    'snowman',
    'spa',
    'spa-outline',
    'speaker',
    'star',
    'stethoscope',
    'subway',
    'swim',
    'tablet-dashboard',
    'tag',
    'tencent-qq',
    'tencent-video',
    'tent',
    'terrain',
    'tik-tok',
    'tooltip-account',
    'traffic-light',
    'train',
    'tram',
    'trophy',
    'trophy-variant',
    'truck',
    'tshirt-crew',
    'twitch',
    'twitter',
    'twitter-box',
    'walk',
    'wallet',
    'watch',
    'weather-partly-cloudy',
    'web',
    'wechat',
    'wrench',
    'youtube'
];
